import { useContext, useMemo } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { IAbookTab } from '@models/Forms/IForms';
import { IFieldElem } from '@models/IFormData';
import { DocumentRuntimeContext } from '@/context/DocumentRuntimeContext';
import { useResolvedAbookTabs } from '@/hooks/useResolvedAbookTabs';
import { getAbookTabsWatchFields, hasAbookTabVisibilityRules, resolveFormAbookTabs } from '@utils/abookTabVisibility';

/** Вкладки окна выбора поля формы: условия показа считаются по живым значениям формы и следят за их сменой. */
export function useFormAbookTabs<TFieldValues extends object>(
    tabs: IAbookTab[] | undefined,
    fields: Record<string, IFieldElem>,
    formMethods: UseFormReturn<TFieldValues>,
    isEdit: boolean,
    isNew: boolean,
): IAbookTab[] | undefined {
    const runtime = useContext(DocumentRuntimeContext);
    const watchFields = useMemo(
        () => (hasAbookTabVisibilityRules(tabs) ? getAbookTabsWatchFields(tabs, fields, formMethods) : []),
        [tabs, fields, formMethods],
    );
    const watched = useWatch({
        control: formMethods.control,
        name: watchFields as never,
        disabled: watchFields.length === 0,
    });
    const revision = useMemo(() => [watched, isEdit, isNew], [watched, isEdit, isNew]);

    return useResolvedAbookTabs(
        tabs,
        (source) => resolveFormAbookTabs(source, fields, formMethods, isEdit, isNew, runtime.requestCache),
        revision,
    );
}
